import './index.scss';
import { FC, Ref } from 'react';
import cx from 'classnames';
import { TextField, Tooltip } from '@material-ui/core';
import { getTrimmedString, translate } from '@utils';
import { TranslationKey } from '@types';

interface EditTextFieldProps {
  value: string;
  contentName: TranslationKey;
  icon: JSX.Element;
  inputRef?: Ref<void>;
  isInputEnabled: boolean;
  onChange: (...args) => void;
  handleConfirmation: (...args) => void;
  debouncedHandleOnClick: (...args) => void;
  isDisabled: boolean;
  charsCount?: number;
}

const EditTextField: FC<EditTextFieldProps> = ({
  value,
  contentName,
  icon,
  inputRef,
  isInputEnabled,
  onChange,
  handleConfirmation,
  debouncedHandleOnClick,
  isDisabled,
  charsCount = 20,
}) => {
  return (
    <div className="text-field" data-testid="etf-container">
      {isInputEnabled ? (
        <TextField
          className="text-field__input"
          value={value}
          placeholder={contentName && translate(contentName)}
          inputRef={inputRef}
          onChange={onChange}
          onClick={debouncedHandleOnClick}
          onBlur={handleConfirmation}
          InputProps={{
            disableUnderline: true,
          }}
          disabled={isDisabled}
        />
      ) : (
        <Tooltip title={value} placement="bottom-start" arrow>
          <span
            data-testid="etf-span"
            className={cx('text-field__span', { disabled: isDisabled })}
            onClick={debouncedHandleOnClick}
          >
            {getTrimmedString(value, charsCount)}
            {icon}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export { EditTextField };
